<template>
  <div class="modal-analysis-container">
    <div ref="modalContent" class="bowx-modal">
      <header class="flex justify-between items-center px-8 h-16 border-b border-line">
        <h1 class="pl-5 w-full text-xl font-bold text-center md:text-3xl">모델 자동분석 결과</h1>
        <div>
          <button @click="onClose"><i class="fi fi-br-cross"></i></button>
        </div>
      </header>

      <div class="bowx-content">
        <div class="p-3 bowx-left">
          <div class="flex items-start">
            <img class="img-3dmodel" src="../../assets/images/3d-model.png" />
            <div
              class="px-3 py-3 mt-1 ml-1 w-full rounded-md"
              :class="[classAnalysis(props.model.modelAnalysis)]"
            >
              <div class="text-lg font-bold">{{ cptAnalysis }}</div>
              <div class="mt-2 mb-3 w-full border-b"></div>
              <div class="text-sm leading-4">
                견적을 문의하시면 전문가가<br />상세검토 후 연락드리겠습니다.
              </div>
            </div>
          </div>
          <div class="mt-5"></div>
          <ul class="mt-2">
            <div v-for="analType in analysisTypes" :key="analType">
              <li
                v-if="'fail' === analysisByType(analType).status"
                @click="onInst(analysisByType(analType).type)"
                class="flex overflow-hidden justify-between items-center p-1 mt-1 bg-white rounded-md border cursor-pointer bowx-analysis border-line hover:border-slate-400"
              >
                <div class="flex items-center">
                  <div
                    class="px-3 py-2 font-semibold rounded-l text-md"
                    :class="[classAnalysis(analysisByType(analType).status)]"
                  >
                    {{ convertStatusToKR(analysisByType(analType).status) }}
                  </div>
                  <div class="ml-3 text-sm">
                    {{ convertTypeToKR(analysisByType(analType).type) }}
                  </div>
                </div>
                <div>
                  <button
                    v-if="'thickness' === analysisByType(analType).type"
                    class="mr-2 bowx-info"
                    :class="[{active: isThicknessView}]"
                    @click.stop="onThickness"
                  >
                    <i class="flex fi fi-rr-eye"></i>
                  </button>
                  <button
                    v-if="'gap' === analysisByType(analType).type"
                    class="mr-2 bowx-info"
                    :class="[{active: isGapView}]"
                    @click.stop="onGap"
                  >
                    <i class="flex fi fi-rr-eye"></i>
                  </button>
                </div>
              </li>
            </div>
            <div v-for="analType in analysisTypes" :key="analType">
              <li
                v-if="
                  'pass' !== analysisByType(analType).status &&
                  'fail' !== analysisByType(analType).status
                "
                @click="onInst(analysisByType(analType).type)"
                class="flex overflow-hidden justify-between items-center p-1 mt-1 bg-white rounded-md border cursor-pointer bowx-analysis border-line hover:border-slate-400"
              >
                <div class="flex items-center">
                  <div
                    class="px-3 py-2 font-semibold rounded-l text-md"
                    :class="[classAnalysis(analysisByType(analType).status)]"
                  >
                    {{ convertStatusToKR(analysisByType(analType).status) }}
                  </div>
                  <div class="ml-3 text-sm">
                    {{ convertTypeToKR(analysisByType(analType).type) }}
                  </div>
                </div>
                <div>
                  <button
                    v-if="'thickness' === analysisByType(analType).type"
                    class="mr-2 bowx-info"
                    :class="[{active: isThicknessView}]"
                    @click.stop="onThickness"
                  >
                    <i class="flex fi fi-rr-eye"></i>
                  </button>
                  <button
                    v-if="'gap' === analysisByType(analType).type"
                    class="mr-2 bowx-info"
                    :class="[{active: isGapView}]"
                    @click.stop="onGap"
                  >
                    <i class="flex fi fi-rr-eye"></i>
                  </button>
                </div>
              </li>
            </div>
          </ul>
          <div
            v-if="cptProblemAnalysis && cptProblemAnalysis.length"
            class="mt-2 mb-2 border-b border-line"
          ></div>
          <ul>
            <div v-for="analType in analysisTypes" :key="analType">
              <li
                v-if="'pass' === analysisByType(analType).status"
                @click="onInst(analysisByType(analType).type)"
                class="flex overflow-hidden justify-between items-center p-1 mt-1 bg-white rounded-md border cursor-pointer bowx-analysis border-line hover:border-slate-400"
              >
                <div class="flex items-center">
                  <div
                    class="px-3 py-2 font-semibold rounded-l text-md"
                    :class="[classAnalysis(analysisByType(analType).status)]"
                  >
                    {{ convertStatusToKR(analysisByType(analType).status) }}
                  </div>
                  <div class="ml-3 text-sm">
                    {{ convertTypeToKR(analysisByType(analType).type) }}
                  </div>
                </div>
              </li>
            </div>
          </ul>
        </div>
        <div ref="rightContent" class="bowx-right">
          <CtxSTLViewer
            v-if="0 < s3Paths.length && isDownloaded"
            :objPaths="s3Paths"
            :wireframeColor="wireframeColor"
            :faceColor="faceColor"
            :defaultModelPosition="modelPosition"
            :defaultModelScale="modelScale"
            :defaultCameraPosition="cameraPosition"
            :frame="{w: rightContent.clientWidth, h: rightContent.clientHeight}"
            :analysis="analysis"
            :analysisRaw="analysisRaw"
            :buildMaxSize="cptBuildMaxSize"
            :manifold="[]"
            :thickness="cptThickness"
            :gap="cptGap"
          />

          <div class="bowx-commands text-2xs md:text-xs">
            <div class="flex items-center">
              <div class="mr-2">
                <button
                  class="bowx-command-btn"
                  :class="[{active: 0 === textuerStatus}]"
                  @click="onSolid"
                >
                  <div class="bowx-solid"></div>
                </button>
                <p class="w-full text-center text-desc" style="margin-top: 0.3rem">면</p>
              </div>
              <div class="mr-2">
                <button
                  class="bowx-command-btn"
                  :class="[{active: 1 === textuerStatus}]"
                  @click="onOpacity"
                >
                  <div class="bowx-opacity"></div>
                </button>
                <p class="w-full text-center text-desc break-keep" style="margin-top: 0.3rem">
                  반투명
                </p>
              </div>
              <div class="mr-2">
                <button
                  class="bowx-command-btn"
                  :class="[{active: 2 === textuerStatus}]"
                  @click="onWire"
                >
                  <div class="bowx-wire"></div>
                </button>
                <p class="w-full text-center text-desc" style="margin-top: 0.3rem">선</p>
              </div>
              <div class="mr-6 ml-5 h-5 border-l border-line2"></div>
              <div class="flex items-center">
                <img class="mr-2 img-divde" src="../../assets/images/three-dimensional.png" />
                <slider
                  v-model="clipingValue"
                  width="100px"
                  color="#666"
                  track-color="#FFF"
                  :alwaysShowHandle="true"
                  :handleScale="1.8"
                  :min="0.01"
                  :max="clipingMaxValue"
                  :step="0.1"
                  @change="onSliderChange"
                ></slider>
              </div>
            </div>
            <div class="mt-2 mb-2 border-b border-line2"></div>
            <div class="flex justify-between items-center">
              <div class="font-semibold text-desc">
                크기: {{ parseFloat(props.model.modelSizeX.toFixed(2)) }} x
                {{ parseFloat(props.model.modelSizeY.toFixed(2)) }} x
                {{ parseFloat(props.model.modelSizeZ.toFixed(2)) }}{{ props.model.modelUnit }}
              </div>
              <div class="font-semibold text-desc">
                부피: {{ numberToComma(props.model.modelVolume) }}㎜<sup>3</sup>
              </div>
            </div>
          </div>

          <div v-if="!isDownloaded" class="justify-center items-center rounded-md bounding-loader">
            <div class="loader-boxs">
              <div class="scene">
                <div class="plane">
                  <div class="cube cube--0">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--0"></div>
                  <div class="cube cube--1">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--1"></div>
                  <div class="cube cube--2">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--2"></div>
                  <div class="cube cube--3">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--3"></div>
                  <div class="cube cube--4">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--4"></div>
                  <div class="cube cube--5">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--5"></div>
                  <div class="cube cube--6">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--6"></div>
                  <div class="cube cube--7">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--7"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="overflow-auto p-3 bowx-left-small" style="height: calc(100vh - 365px)">
          <div class="flex items-start">
            <img class="img-3dmodel" src="../../assets/images/3d-model.png" />
            <div
              class="px-3 py-3 mt-1 ml-1 w-full rounded-md"
              :class="[classAnalysis(props.model.modelAnalysis)]"
            >
              <div class="font-bold text-md md:text-lg">{{ cptAnalysis }}</div>
              <div class="mt-2 mb-3 w-full border-b"></div>
              <div class="text-xs leading-4 md:text-sm">
                견적을 문의하시면 전문가가<br />상세검토 후 연락드리겠습니다.
              </div>
            </div>
          </div>
          <div class="mt-5"></div>
          <ul class="mt-2">
            <div v-for="analType in analysisTypes" :key="analType">
              <li
                v-if="'pass' != analysisByType(analType).status"
                @click="onInst(analysisByType(analType).type)"
                class="flex overflow-hidden justify-between items-center p-1 mt-1 bg-white rounded-md border bowx-analysis border-line"
              >
                <div class="flex items-center">
                  <div
                    class="px-3 py-2 text-sm font-semibold rounded-l md:text-md"
                    :class="[classAnalysis(analysisByType(analType).status)]"
                  >
                    {{ convertStatusToKR(analysisByType(analType).status) }}
                  </div>
                  <div class="ml-3 text-xs md:text-sm">
                    {{ convertTypeToKR(analysisByType(analType).type) }}
                  </div>
                </div>
                <div>
                  <button
                    v-if="'thickness' === analysisByType(analType).type"
                    class="mr-2 bowx-info"
                    @click.stop="onThickness"
                  >
                    <i class="flex fi fi-rr-eye"></i>
                  </button>
                  <button
                    v-if="'gap' === analysisByType(analType).type"
                    class="mr-2 bowx-info"
                    @click.stop="onGap"
                  >
                    <i class="flex fi fi-rr-eye"></i>
                  </button>
                </div>
              </li>
            </div>
          </ul>
          <div
            v-if="cptProblemAnalysis && cptProblemAnalysis.length"
            class="mt-2 mb-2 border-b border-line"
          ></div>
          <ul>
            <div v-for="analType in analysisTypes" :key="analType">
              <li
                v-if="'pass' === analysisByType(analType).status"
                @click="onInst(analysisByType(analType).type)"
                class="flex overflow-hidden justify-between items-center p-1 mt-1 bg-white rounded-md border bowx-analysis border-line"
              >
                <div class="flex items-center">
                  <div
                    class="px-3 py-2 text-sm font-semibold rounded-l md:text-md"
                    :class="[classAnalysis(analysisByType(analType).status)]"
                  >
                    {{ convertStatusToKR(analysisByType(analType).status) }}
                  </div>
                  <div class="ml-3 text-xs md:text-sm">
                    {{ convertTypeToKR(analysisByType(analType).type) }}
                  </div>
                </div>
              </li>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modal-analysis-container {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
}

.bowx {
  &-modal {
    @apply md:rounded-md;

    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 1200px;
    height: 700px;
    background-color: #fff;
  }

  &-content {
    @apply relative md:flex;
  }

  &-left {
    @apply border-r border-line;

    overflow-x: hidden;
    overflow-y: auto;
    width: 280px;
    min-width: 280px;
    background-color: #f9f9f9;
  }
  &-left-small {
    display: none;
  }

  &-right {
    position: relative;
    width: 100%;
    height: 640px;
  }

  &-commands {
    position: absolute;
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
    align-items: center;
    padding: 0.6rem 1.2rem;
    border-radius: 5px;
    background-color: #e8e8e8;
    opacity: 0.8;
  }

  &-command-btn {
    padding: 0.4rem;
    border-radius: 3px;
    transition: background-color 0.3s;

    &:hover {
      background-color: #fff;
    }

    &.active {
      background-color: #fff;
    }
  }

  &-solid {
    border-radius: 5px;
    width: 1.5rem;
    height: 1.5rem;
    background-color: #666;
  }
  &-opacity {
    border-radius: 5px;
    border: 2px solid #666;
    width: 1.5rem;
    height: 1.5rem;
    background-color: #b7b7b7;
  }
  &-wire {
    border-radius: 5px;
    border: 2px solid #888888;
    width: 1.5rem;
    height: 1.5rem;
  }

  &-analysis {
    transition: border 0.2s;

    // &:hover {
    //   @apply border-line2;
    // }
  }

  &-info {
    display: inline-block;
    padding: 0.3rem;
    border-radius: 50%;
    background-color: #f3f3f3;
    transition: all 0.2s;

    &:hover {
      background-color: #e5eaee;
    }
    &.active {
      background-color: #cfd7dc;
    }
  }
}

.img {
  &-divde {
    width: 1.6rem;
    height: 1.6rem;
  }

  &-3dmodel {
    width: 3rem;
    height: 3rem;
  }
}

@media (max-width: 1210px) {
  .bowx {
    &-modal {
      @apply w-full h-full md:rounded-md;

      // margin-top: 10rem;
      // overflow-y: auto;
      // overflow-x: hidden;
      position: initial;
      transform: none;
      background-color: #fff;
    }

    &-left {
      display: none;
    }
    &-left-small {
      display: block;
    }

    &-right {
      position: fixed;
      top: 0px;
      left: 0px;
      position: relative;
      width: 100%;
      height: 300px;
    }

    &-commands {
      bottom: 0.2rem;
    }

    &-solid {
      width: 1.35rem;
      height: 1.35rem;
    }
    &-opacity {
      width: 1.35rem;
      height: 1.35rem;
    }
    &-wire {
      width: 1.35rem;
      height: 1.35rem;
    }
    &-command-btn {
      padding: 0.2rem;
    }
  }

  .img-3dmodel {
    display: none;
  }

  .img {
    &-divde {
      width: 1.35rem;
      height: 1.35rem;
    }
  }
}
</style>

<script setup>
import {ref, computed, onMounted} from "vue";
import {storeToRefs} from "pinia";
import axios from "axios";

import Slider from "vue3-slider";
import CtxSTLViewer from "../components/3d/ctxSTLViewer.vue";
import ModalInstructions from "./modal-instructions.vue";
import {ModelStore} from "../../store/model-store";
import {CommonStore} from "../../store/common-store";
import {OptionsStore} from "../../store/options-store";
import {cfgCommon} from "../../views/components/3d/ctxConfig";
import {numberToComma} from "../../js/utils";

const {isThicknessView, isGapView, isMulitBodyView, textuerStatus, clipingValue, clipingMaxValue} =
  storeToRefs(CommonStore());

const props = defineProps({
  model: {
    type: Object,
    default: null,
  },
});
const emit = defineEmits(["onClose"]);

const isDownloaded = ref(false);

const wireframeColor = ref(cfgCommon.viewer.wireframeColor);
const faceColor = ref(cfgCommon.viewer.faceColor);
const modelPosition = cfgCommon.model.pos;
const modelScale = cfgCommon.model.scale;
const cameraPosition = cfgCommon.camera.pos;

const fileName = ref("");
const analysis = ref();
const analysisRaw = ref();
const s3Paths = ref([]);
const rightContent = ref();

const analysisTypes = ref([
  "loadFile",
  "normalSize",
  "buildSize",
  "checkModel",
  "overVolume",
  "waterproof",
  "multiBody",
  "thickness",
  "gap",
  "hollow",
]);

const AnalysisStatus = {
  Fail: "fail",
  Warn: "warn",
  Caution: "caution",
  Stop: "stop",
  Pass: "pass",
};
const AnalysisStatusKo = {
  Fail: "실패",
  Warn: "경고",
  Caution: "주의",
  Stop: "중지",
  Pass: "통과",
};

const cptAnalysis = computed(() => {
  switch (props.model.modelAnalysis) {
    case AnalysisStatus.Fail:
      return AnalysisStatusKo.Fail;
    case AnalysisStatus.Warn:
      return AnalysisStatusKo.Warn;
    case AnalysisStatus.Caution:
      return AnalysisStatusKo.Caution;
    default:
      return AnalysisStatusKo.Pass;
  }
});
const cptThickness = computed(() => {
  if (analysisRaw.value && analysisRaw.value.analysis[7]) {
    return analysisRaw.value.analysis[7].value;
  } else {
    return [];
  }
});
const cptGap = computed(() => {
  if (analysisRaw.value && analysisRaw.value.analysis[8]) {
    return analysisRaw.value.analysis[8].value;
  } else {
    return [];
  }
});
const cptBuildMaxSize = computed(() => {
  if (!props.model.id) {
    return {};
  }
  const company = OptionsStore().getCompanyById(props.model.modelCompanyId);

  if (!company) {
    return {x: props.model.modelSizeX, y: props.model.modelSizeY, z: props.model.modelSizeZ};
  }

  return {x: company.buildX, y: company.buildY, z: company.buildZ};
});
const cptProblemAnalysis = computed(() => {
  if (!props.model.analysis) return [];
  return props.model.analysis.filter((val) => {
    return (
      val.status === AnalysisStatus.Fail ||
      val.status === AnalysisStatus.Warn ||
      val.status === AnalysisStatus.Caution
    );
  });
});
const cptIsFailed = computed(() => {
  if (props.model && props.model.analysisRaw) {
    if (
      props.model.analysisRaw.analysis &&
      props.model.analysisRaw.analysis[0].status === AnalysisStatus.Fail
    ) {
      return false;
    }
  }
  return true;
});

onMounted(async () => {
  CommonStore().setTextuerStatus(0);
  CommonStore().setIsThicknessView(false);
  CommonStore().setIsGapView(false);

  analysis.value = props.model.analysis;
  fileName.value = props.model.name;

  let key = props.model.modelKey;
  if (fileName.value) {
    const ext = fileName.value.slice(fileName.value.lastIndexOf(".") + 1).toLowerCase();
    if (["stp", "step"].includes(ext)) {
      key = key + ".stp.stl";
    }
  }

  isDownloaded.value = false;
  const resAnalysis = await axios.get(`/models/${props.model.id}/analysis`, {
    params: {
      processId: props.model.modelProcessId,
    },
  });
  analysisRaw.value = resAnalysis.data.result.analysisRaw;
  isDownloaded.value = true;

  if (1 === analysisRaw.value.analysis.length) {
    return;
  }

  const paths = [];
  const resPath = await axios.post(`/models/${props.model.id}`, {
    key: key,
  });
  paths.push(resPath.data.result.signedUrl);
  s3Paths.value = paths;
});

const onClose = () => {
  ModelStore().setCurrentModel({});
  emit("onClose");
};
const onSolid = () => {
  CommonStore().setTextuerStatus(0);
  CommonStore().setIsThicknessView(false);
  CommonStore().setIsGapView(false);
  CommonStore().setIsMulitBodyView(false);
};
const onOpacity = () => {
  CommonStore().setTextuerStatus(1);
  CommonStore().setIsThicknessView(false);
  CommonStore().setIsGapView(false);
  CommonStore().setIsMulitBodyView(false);
};
const onWire = () => {
  CommonStore().setTextuerStatus(2);
  CommonStore().setIsThicknessView(false);
  CommonStore().setIsGapView(false);
  CommonStore().setIsMulitBodyView(false);
};
const onSliderChange = (value) => {
  CommonStore().setClipingValue(value);
};
const onInst = (type) => {
  CommonStore().showModal(ModalInstructions, type);
};
const onThickness = () => {
  CommonStore().setIsGapView(false);
  CommonStore().setIsMulitBodyView(false);
  CommonStore().setIsThicknessView(!isThicknessView.value);
  if (isThicknessView.value) {
    CommonStore().setTextuerStatus(2);
  } else {
    CommonStore().setTextuerStatus(0);
  }
};
const onGap = () => {
  CommonStore().setIsThicknessView(false);
  CommonStore().setIsMulitBodyView(false);
  CommonStore().setIsGapView(!isGapView.value);
  if (isGapView.value) {
    CommonStore().setTextuerStatus(2);
  } else {
    CommonStore().setTextuerStatus(0);
  }
};
const onMulitBody = () => {
  CommonStore().setIsThicknessView(false);
  CommonStore().setIsGapView(false);
  CommonStore().setIsMulitBodyView(!isMulitBodyView.value);
  if (isMulitBodyView.value) {
    CommonStore().setTextuerStatus(3);
  } else {
    CommonStore().setTextuerStatus(0);
  }
};
const convertTypeToKR = (type) => {
  switch (type) {
    case "loadFile":
      return "파일 확장자 검사";
    case "normalSize":
      return "정상모델 크기 검사";
    case "buildSize":
      return "생산가능 크기 검사";
    case "checkModel":
      return "파일 손상 검사";
    case "overVolume":
      return "재료 소모량 검사";
    case "multiBody":
      return "다중 모델 검사";
    case "thickness":
      return "최소 두께 검사";
    case "gap":
      return "단차 검사(양각/음각)";
    case "hollow":
      return "갇힌 공간 검사";
    case "waterproof":
      return "솔리드 구조 검사";
    default:
      return type;
  }
};
const convertStatusToKR = (status) => {
  switch (status) {
    case AnalysisStatus.Fail:
      return AnalysisStatusKo.Fail;
    case AnalysisStatus.Warn:
      return AnalysisStatusKo.Warn;
    case AnalysisStatus.Caution:
      return AnalysisStatusKo.Caution;
    case AnalysisStatus.Stop:
      return AnalysisStatusKo.Stop;
    default:
      return AnalysisStatusKo.Pass;
  }
};
const classAnalysis = (status) => {
  switch (status) {
    case AnalysisStatus.Fail:
      return "cs-badge-disabled";
    case AnalysisStatus.Stop:
      return "cs-badge-stop";
    case AnalysisStatus.Warn:
      return "cs-badge-warn";
    case AnalysisStatus.Caution:
      return "cs-badge-caution";
    default:
      return "cs-badge-pass";
  }
};
const analysisByType = (type) => {
  if (!props.model.analysis) return {type, status: AnalysisStatus.Stop};
  for (let i = 0; i < props.model.analysis.length; i++) {
    if (type === props.model.analysis[i].type) {
      return props.model.analysis[i];
    }
  }
  return {type, status: AnalysisStatus.Stop};
};
</script>
